<template>
  <div>
    <Pane />

    <div class="container">
      <a-form
        :form="form"
        @submit="handleSubmit"
        :label-col="{ span: 8 }"
        :wrapper-col="{ span: 12 }"
        :colon="false"
      >
        <a-row>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item>
              <span class="required" slot="label">申领人</span>
              <a-button block style="text-align: left">
                {{ user.userName }}
              </a-button>
            </a-form-item>
          </a-col>

          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item>
              <span class="required" slot="label">申领部门</span>
              <a-button block style="text-align: left">
                {{ department.deptUniqueName }}
              </a-button>
            </a-form-item>
          </a-col>

          <a-col :span="24">
            <a-form-item
              label="报废理由"
              :label-col="{ span: 4 }"
              :wrapper-col="{ span: 18 }"
            >
              <a-textarea
                :auto-size="{ minRows: 3 }"
                v-decorator="[
                  'remarks',
                  { rules: [{ required: true, message: '请输入！' }] },
                ]"
              />
            </a-form-item>
          </a-col>

          <a-col :lg="12" :md="12" :sm="24" v-if="applyType == '1'">
            <a-form-item
              label="额度类型"
            >
              <a-select v-decorator="[
                  'creditType',
                  { rules: [{ required: true, message: '请输入！' }] },
                ]">
                <a-select-option value="单宗">单宗</a-select-option>
                <a-select-option value="批次">批次</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
            
          <a-col :lg="12" :md="12" :sm="24" v-if="applyType == '1'">
            <a-form-item
              label="使用安装区域"
            >
              <a-input
                v-decorator="[
                  'installationArea',
                  { rules: [{ required: true, message: '请输入！' }] },
                ]"
              />
            </a-form-item>
          </a-col>

          <a-col :span="24" v-if="applyType == '1'">
            <a-form-item
              label="拟报废资产计划处置方案"
              :label-col="{ span: 4 }"
              :wrapper-col="{ span: 18 }"
            >
              <a-textarea
                :auto-size="{ minRows: 3 }"
                v-decorator="[
                  'scrapPlan',
                  { rules: [{ required: true, message: '请输入！' }] },
                ]"
              />
            </a-form-item>
          </a-col>

          <a-col :span="24" v-if="applyType == '1'">
            <a-form-item
              label="附件"
              :label-col="{ span: 4 }"
              :wrapper-col="{ span: 18 }"
            >
              <FileUpload @uploaded="uploaded">
                <a-button type="primary" size="small">上传</a-button>
              </FileUpload>

              <a-table :data-source="fileList" bordered :pagination="false">
                <a-table-column title="附件名">
                  <template slot-scope="text">
                    <a :href="text.completePath" target="_blank" download>
                      {{ $getFileName(text.completePath) }}
                    </a>
                  </template>
                </a-table-column>
                <a-table-column title="操作" align="center" width="120px">
                  <template slot-scope="text, record, index">
                    <a href="#" class="danger" @click.prevent="removeFile(index)"
                      >删除</a
                    >
                  </template>
                </a-table-column>
              </a-table>
            </a-form-item>
          </a-col>

          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item>
              <span class="required" slot="label">资产编码</span>
              <AssetSelector @change="addMaterial">
                <a-button block style="text-align: left">
                  {{ list.assetCode }}
                </a-button>
              </AssetSelector>
            </a-form-item>
          </a-col>
          <template v-if="list.assetCode">
            <a-col :lg="12" :md="12" :sm="24">
              <a-form-item>
                <span class="required" slot="label">资产类别</span>
                <a-button block style="text-align: left;display: flex;align-items: center">
                  <DataDictFinder
                    dictType="fixed_asset_type"
                    :dictValue="list.category.categoryCode"
                  />-
                  {{list.category.subCategoryName}}
                </a-button>
              </a-form-item>
            </a-col>
            <a-col :lg="12" :md="12" :sm="24">
              <a-form-item>
                <span class="required" slot="label">品牌型号</span>
                <a-button block style="text-align: left">
                  {{ list.brandModel}}
                </a-button>
              </a-form-item>
            </a-col>
            <a-col :lg="12" :md="12" :sm="24">
              <a-form-item>
                <span class="required" slot="label">启用日期</span>
                <a-button block style="text-align: left">
                  {{ list.startTime}}
                </a-button>
              </a-form-item>
            </a-col>
            <a-col :lg="12" :md="12" :sm="24">
              <a-form-item>
                <span class="required" slot="label">使用年限(月)</span>
                <a-button block style="text-align: left">
                  {{ list.useMonth}}
                </a-button>
              </a-form-item>
            </a-col>
            <a-col :lg="12" :md="12" :sm="24">
              <a-form-item>
                <span class="required" slot="label">报废时限(月)</span>
                <a-button block style="text-align: left">
                  {{ list.scrapLimitMonths}}
                </a-button>
              </a-form-item>
            </a-col>
            <a-col :lg="12" :md="12" :sm="24">
              <a-form-item>
                <span class="required" slot="label">财务编码</span>
                <a-button block style="text-align: left">
                  {{ list.financialCode}}
                </a-button>
              </a-form-item>
            </a-col>
            <a-col :lg="12" :md="12" :sm="24">
              <a-form-item>
                <span class="required" slot="label">原值</span>
                <a-button block style="text-align: left">
                  {{ list.purchasePrice}}
                </a-button>
              </a-form-item>
            </a-col>
            <a-col :lg="12" :md="12" :sm="24">
              <a-form-item>
                <span class="required" slot="label">折旧金额</span>
                <a-button block style="text-align: left">
                  {{ list.depreciationPrice}}
                </a-button>
              </a-form-item>
            </a-col>
            <a-col :lg="12" :md="12" :sm="24">
              <a-form-item>
                <span class="required" slot="label">净残值率</span>
                <a-button block style="text-align: left">
                  {{ list.netSalvageRate}}
                </a-button>
              </a-form-item>
            </a-col>
            <a-col :lg="12" :md="12" :sm="24">
              <a-form-item>
                <span class="required" slot="label">净值</span>
                <a-button block style="text-align: left">
                  {{ list.netAmount}}
                </a-button>
              </a-form-item>
            </a-col>
            <a-col :lg="12" :md="12" :sm="24" v-if="applyType == '1'">
              <a-form-item>
                <span class="required" slot="label">残值</span>
                <a-button block style="text-align: left">
                  {{ list.netAmount}}
                </a-button>
              </a-form-item>
            </a-col>
          </template>
        </a-row>

        <div class="center">
          <a-space>
            <a-button htmlType="submit" type="primary" :loading="loading">
              {{ id ? "重新提交" : "保存" }}
            </a-button>
            <a-button @click="$close($route.path)">关闭</a-button>
          </a-space>
        </div>
      </a-form>
    </div>
  </div>
</template>

<script>
import request from "@/api/request";
import { mapState, mapGetters } from "vuex";
import EmployeeSelector from "@/components/employee-selector";
import AssetSelector from "./components/assetSelector";
import moment from "moment";
import FileUpload from "@/components/file-upload";
function fetchAsset(data) {
  return request({
    url: "/office-service/fixed-asset/page",
    data,
    method: 'post'
  });
}
function fetchApplyDetail(id) {
  return request({
    url: "/office-service/fixed-asset/scrapped/" + id,
    method: "post",
  });
}
function apply(data) {
  return request({
    url: "/office-service/fixed-asset/to-be-scrapped",
    data,
    method: "post",
  });
}
function reapply(data) {
  return request({
    url: "/office-service/fixed-asset/re-to-be-scrapped",
    data,
    method: "post",
  });
}
export default {
  data() {
    return {
      applyType: 0,
      index: 0,
      assetsCategoryList: [],
      selectedUser: {},
      form: this.$form.createForm(this),

      list: {
        assetCode: "",
        category: {
          categoryCode: "",
          subCategoryName: "",
        },
      },

      loading: false,

      id: null, // 已发起申领申请的 id
      fileList: [],
    };
  },
  components: {
    EmployeeSelector,
    AssetSelector,
    FileUpload
  },
  mounted() {
    const { query } = this.$route;
    const { id } = query || {};
    this.applyType = this.$route.path.split("/")[this.$route.path.split("/").length - 1];
    if (id) {
      // 重新提交
      this.id = id;
      fetchApplyDetail(id).then((res) => {
        console.log("result", res);
        if (res) {
          this.form.setFieldsValue({
            remarks: res.description,
          });

          this.list = res.fixedAsset
        }
      });
    }

  },

  computed: {
    ...mapState("auth", ["user"]),
    ...mapGetters("auth", ["department"]),

    ...mapGetters("setting", ["findDataDict"]),

    typeList() {
      return this.findDataDict("giftType");
    },
  },

  methods: {
    // 上传附件
    uploaded(list) {
      this.fileList = list;
    },
    removeFile(index) {
      this.fileList.splice(index, 1);
    },
    handleSearch(e) {
      fetchAsset({
        pageNum: 1,
        pageSize: 10000,
        assetCode: e.target.value,
      })
    },
    showEmployeeSelector(index) {
      this.index = index;
    },
    addMaterial(record) {
      this.list = record
      const date = moment(record.startTime);
      let startTime = null;
      // 判断是否是当月的第一天（即日期为1号）
      if (date.date() === 1) {
        // 是当月第一天，返回当天（当月第一天）
        startTime = date.startOf('month').format('YYYY-MM-DD')
      } else {
        // 不是当月第一天，返回下个月第一天
        startTime = date.add(1, 'month').startOf('month').format('YYYY-MM-DD')
      }
      this.list.useMonth = moment().diff(moment(startTime), "months") + 1;
      let rato = this.list.useMonth / this.list.scrapLimitMonths
      if(rato > 1){
        rato = 1
      }
      this.list.depreciationPrice = this.list.purchasePrice * (1 - this.list.netSalvageRate) * rato;
      this.list.depreciationPrice =this.list.depreciationPrice.toFixed(2);
      this.list.depreciationPrice = parseFloat(this.list.depreciationPrice);
      this.list.netAmount = (this.list.purchasePrice - this.list.depreciationPrice).toFixed(2);
      this.list.netAmount = parseFloat(this.list.netAmount);
    },
    renderSubType(type, subType) {
      const obj = this.typeList.find((item) => item.value === type);
      if (obj && Array.isArray(obj.children)) {
        const subTypeObj = obj.children.find((item) => item.value === subType);
        if (subTypeObj) {
          return subTypeObj.name;
        } else {
          return "";
        }
      } else {
        return "";
      }
    },

    // 用户选择了品名和数量
    add(payload) {
      const index = this.list.findIndex((item) => item.id === payload.id);
      if (index === -1) {
        this.list.push(payload);
      } else {
        this.list.splice(index, 1, payload);
      }
    },

    remove(index) {
      this.list.splice(index, 1);
    },

    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          if (this.list.length === 0) {
            this.$message.error("请添加固定资产");
            return;
          }

          this.loading = true;

          if (this.id) {
            reapply({
              id: this.id,
              applyType: this.applyType,
              applicantId: this.user.uuid,
              applicant: this.user.userName,
              applicantDeptId: this.department.deptId,
              applicantDeptName: this.department.deptUniqueName,
              description: values.remarks,
              creditType: values.creditType,
              installationArea: values.installationArea,
              scrapPlan: values.scrapPlan,
              filePath: this.fileList.map((item) => item.completePath).join(","),
              fixedAsset: this.list
            })
              .then(() => {
                this.$close(this.$route.path);
              })
              .finally(() => {
                this.loading = false;
              });
          } else {
            apply({
              applyType: this.applyType,
              applicantId: this.user.uuid,
              applicant: this.user.userName,
              applicantDeptId: this.department.deptId,
              applicantDeptName: this.department.deptUniqueName,
              description: values.remarks,
              creditType: values.creditType,
              installationArea: values.installationArea,
              scrapPlan: values.scrapPlan,
              filePath: this.fileList.map((item) => item.completePath).join(","),
              fixedAsset: this.list,
            })
              .then(() => {
                this.list = [];
                this.form.resetFields();
                this.fileList = [];
              })
              .finally(() => {
                this.loading = false;
              });
          }
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  background-color: #fff;
  padding: 24px 160px;
}

.title {
  margin-top: 30px;
  margin-bottom: 18px;
  font-size: 14px;
  font-weight: bold;
  line-height: 22px;
  color: #1890ff;
}

.center {
  margin-top: 80px;
}
</style>
